import React, { useEffect, useState, useRef } from 'react'
import "./View.scss";
import Economy_active from '../../assets/image/Economy_active.png'
import Economy_close from '../../assets/image/Economy_close.png'
import Productivity_active from '../../assets/image/Productivity_active.png'
import Productivity_close from '../../assets/image/Productivity_close.png'
import { Link, useHistory } from "react-router-dom";
import useQuery from '../../components/useQuery'
import Chart from "react-apexcharts";
import Chart2 from "react-google-charts";
import html2canvas from 'html2canvas';
import ImageResize from "image-resize";

import domtoimage from "dom-to-image";
import moment from "moment";
import { apiUrl, key_wijmo, apiUrl_image } from '../../constants';

import * as wjChart from '@grapecity/wijmo.react.chart';
import * as wjChartAnalytics from '@grapecity/wijmo.react.chart.analytics';
import * as wjcCore from '@grapecity/wijmo';
import * as wjChartAnimate from '@grapecity/wijmo.react.chart.animation';
import Swal from "sweetalert2";

const ViewTCO = (props) => {
    const history = useHistory();
    const login_token = useQuery();
    const [token, settoken] = useState(login_token)
    const [dataselect, setdataselect] = useState([])
    const [displayModalSelect, setdisplayModalSelect] = useState(false)

    const [mode, setmode] = useState(1)

    const [select, setselect] = useState("TCO (Value)")
    const [select_id, setselect_id] = useState(1)

    const [graph11, setgraph11] = useState({
        options: {},
        series: []
    })
    const [graph12, setgraph12] = useState({
        options: {},
        series: []
    })
    const [graph13, setgraph13] = useState({
        options: {},
        series: []
    })

    const [graph2, setgraph2] = useState({})

    const [graph3, setgraph3] = useState({})
    const [graph3data, setgraphdata3] = useState([])
    const [graph4, setgraph4] = useState({})
    const [graph4data, setgraphdata4] = useState([])

    const [snap, setsnap] = useState(0)

    useEffect(() => {
        wjcCore.setLicenseKey(key_wijmo);
        setdataselect([
            { id: 1, name: "TCO (Value)" },
            { id: 2, name: "TCO (Graph)" },
            { id: 3, name: "Fuel consumption" },
            { id: 4, name: `${props.location.state.data.ModelName1} TCO Composition (Graph)` },
            { id: 5, name: `${props.location.state.data.ModelName2} TCO Composition (Graph)` },
        ])
        setallgraph(0)


        setgraph11(
            {
                options: {
                    chart: {
                        id: "TCO (Graph)"
                    },
                    colors: ['#3DB3A7', '#F1B950'],
                    xaxis: {
                        categories: [`TCO ratio (${props.location.state.currency}/h)`]
                    },

                },
                series: [
                    {
                        name: `${props.location.state.data.ModelName1}`,
                        data: [mode === 0 ? Number(props.location.state.data.ETcoRadio1) : Number(props.location.state.data.TcoRadio1)]
                    },
                    {
                        name: `${props.location.state.data.ModelName2}`,
                        data: [mode === 0 ? Number(props.location.state.data.ETcoRadio2) : Number(props.location.state.data.TcoRadio2)]
                    }
                ]
            })

        setgraph12(
            {
                options: {
                    chart: {
                        id: "TCO (Graph)"
                    },
                    colors: ['#3DB3A7', '#F1B950'],
                    xaxis: {
                        categories: [`Productivity ratio (m³/h)`]
                    },

                },
                series: [
                    {
                        name: `${props.location.state.data.ModelName1}`,
                        data: [mode === 0 ? Number(props.location.state.data.EProdRadio1) : Number(props.location.state.data.ProdRadio1)]
                    },
                    {
                        name: `${props.location.state.data.ModelName2}`,
                        data: [mode === 0 ? Number(props.location.state.data.EProdRadio2) : Number(props.location.state.data.ProdRadio2)]
                    }
                ]
            })

        setgraph13(
            {
                options: {
                    chart: {
                        id: "TCO (Graph)"
                    },
                    colors: ['#3DB3A7', '#F1B950'],
                    xaxis: {
                        categories: [`TCO/Productivity ratio (${props.location.state.currency}/m³)`]
                    },

                },
                series: [
                    {
                        name: `${props.location.state.data.ModelName1}`,
                        data: [mode === 0 ? Number(props.location.state.data.ETcoProd1) : Number(props.location.state.data.TcoProd1)]
                    },
                    {
                        name: `${props.location.state.data.ModelName2}`,
                        data: [mode === 0 ? Number(props.location.state.data.ETcoProd2) : Number(props.location.state.data.TcoProd2)]
                    }
                ]
            })
            window.scrollTo(0, 0);
    }, [])

    const base64toFile = (dataurl, filename) => {
        var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }


    const saveScreen = async () => {
        await setsnap(1)
        await window.scrollTo(0, 0);
        const el = document.getElementsByClassName("save_graph")[0];
        el.style.height = "100%"
        await html2canvas(document.getElementById("capture"), {
            onclone: function () {
                el.style.height = 0
            }
        }).then(canvas => {
            var dataURL = canvas.toDataURL('image/jpg')
            console.log(dataURL)
            if (dataURL !== '') {
                var cover = base64toFile(dataURL, "downloadName.jpg");
                sendtoapi(cover)
            }
        })
    }

    const sendtoapi = async file => {
        // var checkcallback = false;
        var token_get = localStorage.getItem('token')
        var cover_token_get = JSON.parse(token_get)
        var formdata = new FormData()
        formdata.append('Files', file, file.name)

        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${cover_token_get}`);
        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        }
        fetch(`${apiUrl}/upload/`, requestOptions)
            .then(response => response.text())
            .then(async (resu) => {
                Swal.fire("Report created");
                let res = JSON.parse(resu)
                window.location.href = `callback?path_url=${apiUrl_image}/${res.data}`
            })
            .catch(error => {
                // setsnap(0)
            })
    }

    const switchmode = (mode) => {
        setmode(mode)
        setallgraph(mode)
    }

    const setallgraph = (mode) => {

        setgraph11(
            {
                options: {
                    chart: {
                        id: "TCO (Graph)"
                    },
                    colors: ['#3DB3A7', '#F1B950'],
                    xaxis: {
                        categories: [`TCO ratio (${props.location.state.currency}/h)`]
                    },

                },
                series: [
                    {
                        name: `${props.location.state.data.ModelName1}`,
                        data: [mode === 0 ? Number(props.location.state.data.ETcoRadio1) : Number(props.location.state.data.TcoRadio1)]
                    },
                    {
                        name: `${props.location.state.data.ModelName2}`,
                        data: [mode === 0 ? Number(props.location.state.data.ETcoRadio2) : Number(props.location.state.data.TcoRadio2)]
                    }
                ]
            })

        setgraph12(
            {
                options: {
                    chart: {
                        id: "TCO (Graph)"
                    },
                    colors: ['#3DB3A7', '#F1B950'],
                    xaxis: {
                        categories: [`Productivity ratio (m³/h)`]
                    },

                },
                series: [
                    {
                        name: `${props.location.state.data.ModelName1}`,
                        data: [mode === 0 ? Number(props.location.state.data.EProdRadio1) : Number(props.location.state.data.ProdRadio1)]
                    },
                    {
                        name: `${props.location.state.data.ModelName2}`,
                        data: [mode === 0 ? Number(props.location.state.data.EProdRadio2) : Number(props.location.state.data.ProdRadio2)]
                    }
                ]
            })

        setgraph13(
            {
                options: {
                    chart: {
                        id: "TCO (Graph)"
                    },
                    colors: ['#3DB3A7', '#F1B950'],
                    xaxis: {
                        categories: [`TCO/Productivity ratio (${props.location.state.currency}/m³)`]
                    },

                },
                series: [
                    {
                        name: `${props.location.state.data.ModelName1}`,
                        data: [mode === 0 ? Number(props.location.state.data.ETcoProd1) : Number(props.location.state.data.TcoProd1)]
                    },
                    {
                        name: `${props.location.state.data.ModelName2}`,
                        data: [mode === 0 ? Number(props.location.state.data.ETcoProd2) : Number(props.location.state.data.TcoProd2)]
                    }
                ]
            })

        setgraph2(
            {
                options: {
                    chart: {
                        id: "Fuel consumption"
                    },
                    colors: ['#3DB3A7', '#F1B950'],
                    xaxis: {
                        categories: [" "]
                    },

                },
                series: [
                    {
                        name: `${props.location.state.data.ModelName1}`,
                        data: [Number(props.location.state.data.FuelConsumRadio1)]
                    },
                    {
                        name: `${props.location.state.data.ModelName2}`,
                        data: [Number(props.location.state.data.FuelConsumRadio2)]
                    }
                ]
            })
        // setgraphdata3([
        //     ["TCO composition", "", "", "", ""],
        //     ["Initial", 0, 0, 0, Number(`${props.location.state.data.Initial1}`)],
        //     ["Fuel", 0, 0, Number(`${props.location.state.data.Initial1}`), Number(`${props.location.state.data.Fuel1}`)],
        //     ["Maintenance", 0, Number(`${props.location.state.data.Initial1}`), Number(`${props.location.state.data.Fuel1}`), Number(`${props.location.state.data.Mainten1}`)],
        //     ["Labor", Number(`${props.location.state.data.Initial1}`), Number(`${props.location.state.data.Fuel1}`), Number(`${props.location.state.data.Mainten1}`), Number(`${props.location.state.data.Labor1}`)],
        //     ["Resale", Number(`${props.location.state.data.Fuel1}`), Number(`${props.location.state.data.Mainten1}`), Number(`${props.location.state.data.Labor1}`), Number(`${props.location.state.data.Resale1}`)],
        //     ["TCO", Number(`${props.location.state.data.Mainten1}`), Number(`${props.location.state.data.Labor1}`), Number(`${props.location.state.data.Resale1}`), Number(`${props.location.state.data.TcO1}`)],
        // ])

        // setgraph3({
        //     legend: "none",
        //     bar: { groupWidth: "100%" },
        //     candlestick: {
        //         fallingColor: { strokeWidth: 0, fill: "#7F7F7F" },
        //         risingColor: { strokeWidth: 0, fill: "#FD2254" }
        //     }
        // })


        // setgraphdata4([
        //     ["TCO composition", "", "", "", ""],
        //     ["Initial", 0, 0, 0, Number(`${props.location.state.data.initial2}`)],
        //     ["Fuel", 0, 0, Number(`${props.location.state.data.initial2}`), Number(`${props.location.state.data.fuel2}`)],
        //     ["Maintenance", 0, Number(`${props.location.state.data.initial2}`), Number(`${props.location.state.data.fuel2}`), Number(`${props.location.state.data.mainten2}`)],
        //     ["Labor", Number(`${props.location.state.data.initial2}`), Number(`${props.location.state.data.fuel2}`), Number(`${props.location.state.data.mainten2}`), Number(`${props.location.state.data.Labor2}`)],
        //     ["Resale", Number(`${props.location.state.data.fuel2}`), Number(`${props.location.state.data.mainten2}`), Number(`${props.location.state.data.Labor2}`), Number(`${props.location.state.data.Resale2}`)],
        //     ["TCO", Number(`${props.location.state.data.mainten2}`), Number(`${props.location.state.data.Labor2}`), Number(`${props.location.state.data.Resale2}`), Number(`${props.location.state.data.tcO2}`)],
        // ])

        // setgraph4({
        //     legend: "none",
        //     bar: { groupWidth: "100%" },
        //     candlestick: {
        //         fallingColor: { strokeWidth: 0, fill: "#7F7F7F" },
        //         risingColor: { strokeWidth: 0, fill: "#FD2254" },
        //     }
        // })

        setgraphdata3([
            {
                date: 'Initial',
                sales2: Number(remove(`${props.location.state.data.Initial1}`)),
                sales: Number(`${props.location.state.data.Initial1}`),
            },
            {
                date: 'Fuel',
                sales2: Number(remove(`${props.location.state.data.Fuel1}`)),
                sales: Number(`${props.location.state.data.Fuel1}`),
            },
            {
                date: 'Maintenance',
                sales2: Number(remove(`${props.location.state.data.Mainten1}`)),
                sales: Number(`${props.location.state.data.Mainten1}`),
            },
            {
                date: 'Labor',
                sales2: Number(remove(`${props.location.state.data.Labor1}`)),
                sales: Number(`${props.location.state.data.Labor1}`),
            },
            {
                date: 'Resale',
                sales2: Number(remove(`${props.location.state.data.Resale1}`)),
                sales: Number(`${props.location.state.data.Resale1}`),
            },
            {
                date: 'TCO',
                sales2: Number(remove(`${props.location.state.data.TCO1}`)),
                sales: Number(`${props.location.state.data.TCO1}`),
            },
        ])

        setgraphdata4([
            {
                date: 'Initial',
                sales2: Number(remove(`${props.location.state.data.Initial2}`)),
                sales: Number(`${props.location.state.data.Initial2}`),
            },
            {
                date: 'Fuel',
                sales2: Number(remove(`${props.location.state.data.Fuel2}`)),
                sales: Number(`${props.location.state.data.Fuel2}`),
            },
            {
                date: 'Maintenance',
                sales2: Number(remove(`${props.location.state.data.Mainten2}`)),
                sales: Number(`${props.location.state.data.Mainten2}`),
            },
            {
                date: 'Labor',
                sales2: Number(remove(`${props.location.state.data.Labor2}`)),
                sales: Number(`${props.location.state.data.Labor2}`),
            },
            {
                date: 'Resale',
                sales2: Number(remove(`${props.location.state.data.Resale2}`)),
                sales: Number(`${props.location.state.data.Resale2}`),
            },
            {
                date: 'TCO',
                sales2: Number(remove(`${props.location.state.data.TCO2}`)),
                sales: Number(`${props.location.state.data.TCO2}`),
            },
        ])
    }

    const remove = (number) => {
        if (number) {
            var numbers = removeDegitSaraly(number);
            var parts = Number(numbers).toString().split(".");
            parts[0] = parts[0].replace("-", "");
            let numbera = parts.join(".");
            return numbera;
        } else if (Number(number) === 0) {
            return 0;
        } else {
            return " ";
        }
    };

    const onWaterfallInitialized = (sender) => {
        sender.styles = {
            start: { fill: 'blue', stroke: 'blue' },
            total: { fill: 'yellow', stroke: 'yellow' },
            falling: { fill: '#F29191', stroke: '#EEC4C4' },
            rising: { fill: '#94D0CC', stroke: '#D1D9D9' },
            connectorLines: { stroke: 'blue', 'stroke-dasharray': '3, 1' }
        };
    };

    const setDegitSalary = (number) => {
        if (number) {
            var numbers = removeDegitSaraly(number);
            var parts = Number(numbers).toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            let numbera = parts.join(".");
            return numbera;
        } else if (Number(number) === 0) {
            return 0;
        } else {
            return " ";
        }
    };

    const removeDegitSaraly = (number) => {
        if (number) {
            var parts = number.toString().split(".");
            parts[0] = parts[0].replace(",", "");
            let numbera = parts.join(".");
            return numbera;
        } else {
            return " ";
        }
    };
    const selectItemSelect = (item) => {
        setselect(item.name)
        setselect_id(item.id)
        setdisplayModalSelect(!displayModalSelect)
        if (item.id !== 1 || item.id !== 2) {
            switchmode(0)
        }
    }

    const handleDisplayModalSelect = () => {
        setdisplayModalSelect(!displayModalSelect)
    }

    return (
        <>
            <div id="capture">
                <div className={snap === 1 ? " " : "sticky-headder-result"}>
                    <div className="headder-cal-group-result shadow-result">
                        <div className="d-flex justify-content-between">
                            <div className="row">
                                <div className="col-2" style={{ paddingTop: "5px" }} onClick={() =>
                                    history.push(`/History?login_token=${token}`)
                                }>
                                    <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.35031 0.7256C7.64636 0.4248 8.11244 0.4248 8.40848 0.7256C8.69453 1.01624 8.69453 1.49995 8.40848 1.78991L3.04292 7.24157H19.7485C20.1613 7.24157 20.5 7.57488 20.5 7.99424C20.5 8.4136 20.1613 8.75776 19.7485 8.75776H3.04292L8.40848 14.1992C8.69453 14.5 8.69453 14.9844 8.40848 15.2744C8.11244 15.5752 7.64636 15.5752 7.35031 15.2744L0.714536 8.53216C0.428488 8.24152 0.428488 7.7578 0.714536 7.46784L7.35031 0.7256Z" fill="black" />
                                    </svg>

                                </div>
                                <div className="col-10">
                                    <p style={{ color: "#000", fontSize: "16px" }}>View {props.location.state.events ? props.location.state.events.CustomerName : ""}</p>
                                    <p style={{ color: "#586172", fontSize: "12px", marginTop: "-20px" }}>{props.location.state ? props.location.state.comparison_model : ""}</p>
                                </div>

                            </div>
                            <a style={{ color: "#3b4fbc", fontSize: "16px", textAlign: "right", paddingTop: "5px" }}>
                                {/* <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M17.2703 0C17.6733 0 18 0.32671 18 0.729728V8.51349C18 8.91651 17.6733 9.24322 17.2703 9.24322C16.8673 9.24322 16.5405 8.91651 16.5405 8.51349V2.49145L8.05657 10.9754C7.77159 11.2604 7.30955 11.2604 7.02458 10.9754C6.7396 10.6904 6.7396 10.2284 7.02458 9.94344L15.5086 1.45946H9.48651C9.0835 1.45946 8.75678 1.13275 8.75678 0.729728C8.75678 0.32671 9.0835 0 9.48651 0H17.2703ZM4.62165 2.43243C3.66984 2.43243 3.33708 2.43869 3.08208 2.50702C2.32661 2.70945 1.73652 3.29954 1.53409 4.05501C1.46577 4.31001 1.4595 4.64276 1.4595 5.59458V11.4324C1.4595 12.829 1.46105 13.8031 1.55986 14.538C1.65585 15.2519 1.83142 15.63 2.1007 15.8993C2.36998 16.1686 2.74805 16.3442 3.46199 16.4401C4.19692 16.5389 5.17098 16.5405 6.56759 16.5405H12.4054C13.3572 16.5405 13.69 16.5342 13.945 16.4659C14.7005 16.2635 15.2905 15.6734 15.493 14.9179C15.5613 14.6629 15.5676 14.3302 15.5676 13.3783C15.5676 12.9753 15.8943 12.6486 16.2973 12.6486C16.7003 12.6486 17.027 12.9753 17.027 13.3783L17.027 13.491C17.0273 14.2869 17.0275 14.8299 16.9027 15.2956C16.5653 16.5548 15.5818 17.5382 14.3227 17.8756C13.857 18.0004 13.3139 18.0002 12.5181 18H12.5181L12.4054 18H6.51421C5.18358 18 4.11106 18 3.26752 17.8866C2.39174 17.7688 1.65435 17.5169 1.0687 16.9313C0.483059 16.3456 0.231163 15.6083 0.113419 14.7325C9.53674e-06 13.889 2.47955e-05 12.8164 4.3869e-05 11.4859V11.4858V5.59458L1.90735e-05 5.48193V5.48188C-0.000240326 4.68604 -0.000417709 4.14299 0.124371 3.67727C0.46175 2.41816 1.44523 1.43467 2.70435 1.09729C3.17007 0.972505 3.71313 0.972684 4.50899 0.972946L4.62165 0.97297C5.02467 0.97297 5.35138 1.29968 5.35138 1.7027C5.35138 2.10572 5.02467 2.43243 4.62165 2.43243Z" fill="black" />
                                </svg> */}

                            </a>
                        </div>

                        <div style={{ marginTop: "5px", paddingBottom: "16px", backgroundColor: "#fff" }}>

                            {select_id === 1 || select_id === 2 ?

                                <>
                                    {mode === 1 ?

                                        <a style={{
                                            background: "#FFFFFF",
                                            border: "1px solid #000000",
                                            boxSizing: "border-box",
                                            borderRadius: "10px",
                                            padding: "10px",
                                        }}
                                            onClick={() => switchmode(1)}
                                        >
                                            <img
                                                src={Productivity_active}
                                                style={{
                                                    paddingRight: "10px"

                                                }}
                                            />
                                            Productivity

                                        </a>
                                        :
                                        <a style={{
                                            background: "#FAFAFA",
                                            border: "1px solid #E0E0E0",
                                            boxSizing: "border-box",
                                            borderRadius: "10px",
                                            padding: "10px",
                                            color: "#999999"
                                        }}
                                            onClick={() => switchmode(1)}
                                        >
                                            <img
                                                src={Productivity_close}
                                                style={{
                                                    paddingRight: "10px"

                                                }}
                                            />
                                            Productivity
                                        </a>

                                    }
                                </>

                                :
                                <a style={{
                                    background: "##FAFAFA",
                                    border: "1px solid #E0E0E0",
                                    boxSizing: "border-box",
                                    borderRadius: "10px",
                                    padding: "10px",
                                    color: "#999999"
                                }}>
                                    <img
                                        src={Productivity_close}
                                        style={{
                                            paddingRight: "10px"

                                        }}
                                    />
                                    Productivity

                                </a>}
                            {select_id === 1 || select_id === 2 ?
                                <>
                                    {mode === 0 ?

                                        <a style={{
                                            background: "#FFFFFF",
                                            border: "1px solid #000000",
                                            boxSizing: "border-box",
                                            borderRadius: "10px",
                                            padding: "10px",
                                            marginLeft: "5px",

                                        }}
                                            onClick={() => switchmode(0)}

                                        >
                                            <img
                                                src={Economy_active}
                                                style={{
                                                    paddingRight: "10px"
                                                }}
                                            />


                                            Economy

                                        </a>
                                        :
                                        <a style={{
                                            background: "#FAFAFA",
                                            border: "1px solid #E0E0E0",
                                            boxSizing: "border-box",
                                            borderRadius: "10px",
                                            padding: "10px",
                                            color: "#999999",
                                            marginLeft: "5px",
                                        }}
                                            onClick={() => switchmode(0)}

                                        >
                                            <img
                                                src={Economy_close}
                                                style={{
                                                    paddingRight: "10px"
                                                }}
                                            />


                                            Economy

                                        </a>}
                                </> :
                                <a style={{
                                    background: "#FAFAFA",
                                    border: "1px solid #E0E0E0",
                                    boxSizing: "border-box",
                                    borderRadius: "10px",
                                    padding: "10px",
                                    color: "#999999",
                                    marginLeft: "5px",
                                }}
                                    onClick={() => switchmode(0)}

                                >
                                    <img
                                        src={Economy_close}
                                        style={{
                                            paddingRight: "10px"
                                        }}
                                    />


                                    Economy

                                </a>
                            }
                        </div>
                    </div>
                </div>
                {snap === 1 ? null :
                    <div className="container" style={{ marginTop: "150px" }}>
                    </div>
                }
                <div className="container">
                    <div style={{ backgroundColor: "#F6F7FB" }}>

                        <div style={{ marginTop: "5px", paddingBottom: "16px", backgroundColor: "#fff" }}>
                            <p style={{
                                fontStyle: "normal",
                                fontWeight: "600",
                                fontSize: "14px",
                                lineHeight: "17px",
                                color: "#000000",
                            }}>Condition</p>

                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>Lifetime working (Hour):</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {props.location.state.events.LifeTime ? setDegitSalary(props.location.state.events.LifeTime) : ""}
                                </p>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>Working mode:</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {props.location.state.events.WorkingMode} mode
                                </p>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>Idling ratio (%):</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {props.location.state.events.LingRatioID} % {Number(props.location.state.events.LingRatioID) === 30 ? "(average)" : ""}

                                </p>
                            </div>

                            <div style={{
                                border: "1px dashed #E0E0E0",
                                margin: "10px"
                            }}></div>

                            <div className="container">
                                <div className="row"
                                    style={{
                                        backgroundColor: "#F9FAFE",
                                        borderRadius: "10px",
                                        height: "27px"
                                    }}
                                >
                                    <div className="col-5">
                                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="4" cy="4" r="4" fill="#3DB3A8" />
                                        </svg>
                                        <span
                                            style={{
                                                fontStyle: "normal",
                                                fontWeight: "600",
                                                fontSize: "12px",
                                                lineHeight: "14px",
                                                color: "#3DB3A8",
                                                alignItems: "center",
                                                textAlign: "center",
                                                marginLeft: "3px"
                                            }}
                                        >

                                            {props.location.state.data.ModelName1}
                                        </span>

                                    </div>
                                    <div className="col-2" style={{ textAlign: "center" }}>
                                        <span
                                            style={{
                                                fontStyle: "normal",
                                                fontWeight: "600",
                                                fontSize: "12px",
                                                lineHeight: "14px",
                                                color: "#3DB3A8",
                                                alignItems: "center",
                                                textAlign: "center"
                                            }}
                                        >
                                            Model
                                        </span>

                                    </div>
                                    <div className="col-5" style={{ textAlign: "end" }}>
                                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="4" cy="4" r="4" fill="#EBB63F" />
                                        </svg>
                                        <span
                                            style={{
                                                fontStyle: "normal",
                                                fontWeight: "600",
                                                fontSize: "12px",
                                                lineHeight: "14px",
                                                color: "#EBB63F",
                                                alignItems: "center",
                                                textAlign: "center",
                                                marginLeft: "3px"
                                            }}
                                        >

                                            {props.location.state.data.ModelName2}
                                        </span>

                                    </div>
                                </div>
                            </div>


                            <div className="container">
                                <div className="row"
                                    style={{
                                        backgroundColor: "#F9FAFE",
                                        borderRadius: "10px",
                                        marginTop: "5px",
                                        height: "49px",
                                        alignItems: "center",

                                    }}
                                >
                                    <div className="col-4">

                                        <span
                                            style={{
                                                fontStyle: "normal",
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                lineHeight: "17px",
                                                color: "#14274C",
                                                marginLeft: "3px"
                                            }}
                                        >

                                            {setDegitSalary(props.location.state.events.ModelPrice1)}
                                        </span>

                                    </div>
                                    <div className="col-4" style={{ textAlign: "center" }}>
                                        <span
                                            style={{
                                                fontStyle: "normal",
                                                fontWeight: "600",
                                                fontSize: "12px",
                                                lineHeight: "14px",
                                                color: "#3DB3A8",
                                                alignItems: "center",
                                                textAlign: "center"
                                            }}
                                        >
                                            Price<br />
                                            ({props.location.state.currency})
                                        </span>

                                    </div>
                                    <div className="col-4" style={{ textAlign: "end" }}>

                                        <span
                                            style={{
                                                fontStyle: "normal",
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                lineHeight: "17px",
                                                color: "#14274C",
                                                textAlign: "right",
                                                marginLeft: "3px"
                                            }}
                                        >

                                            {setDegitSalary(props.location.state.events.ModelPrice2)}
                                        </span>

                                    </div>
                                </div>
                            </div>


                            <div className="container">
                                <div className="row"
                                    style={{
                                        backgroundColor: "#F9FAFE",
                                        borderRadius: "10px",
                                        marginTop: "5px",
                                        height: "49px",
                                        alignItems: "center",

                                    }}
                                >
                                    <div className="col-4">

                                        <span
                                            style={{
                                                fontStyle: "normal",
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                lineHeight: "17px",
                                                color: "#14274C",
                                                marginLeft: "3px"
                                            }}
                                        >

                                            {setDegitSalary(props.location.state.events.ModelBucket1)} <>m<sup>3</sup></>
                                        </span>

                                    </div>
                                    <div className="col-4" style={{ textAlign: "center" }}>
                                        <span
                                            style={{
                                                fontStyle: "normal",
                                                fontWeight: "600",
                                                fontSize: "12px",
                                                lineHeight: "14px",
                                                color: "#3DB3A8",
                                                alignItems: "center",
                                                textAlign: "center"
                                            }}
                                        >
                                            Bucket
                                        </span>

                                    </div>
                                    <div className="col-4" style={{ textAlign: "end" }}>

                                        <span
                                            style={{
                                                fontStyle: "normal",
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                lineHeight: "17px",
                                                color: "#14274C",
                                                textAlign: "right",
                                                marginLeft: "3px"
                                            }}
                                        >

                                            {setDegitSalary(props.location.state.events.ModelBucket2)} <>m<sup>3</sup></>
                                        </span>

                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

                <div style={{ backgroundColor: "#F7F8FB", paddingTop: "5px", marginBottom: "5px", }}>
                </div>

                <div className="container">

                    <div style={{ marginTop: "5px", paddingBottom: "16px", backgroundColor: "#fff" }}>
                        <div className="container">
                            <div className="row"
                                style={{
                                    backgroundColor: "#F9FAFE",
                                    borderRadius: "10px",
                                    marginTop: "5px",
                                    height: "49px",
                                    alignItems: "center",
                                }}
                                onClick={() => handleDisplayModalSelect(!displayModalSelect)}
                            >
                                <div className="col-10">
                                    <span
                                        style={{
                                            fontStyle: "normal",
                                            fontWeight: "normal",
                                            fontSize: "14px",
                                            lineHeight: "17px",
                                            color: "#000000",
                                        }}
                                    >
                                        {select}
                                    </span>
                                </div>
                                <div className="col-2" style={{ textAlign: "end" }}>

                                    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.180798 0.184424C0.399947 -0.0391208 0.742881 -0.0594431 0.984537 0.123457L1.05377 0.184424L6 5.23006L10.9462 0.184424C11.1654 -0.0391204 11.5083 -0.0594426 11.75 0.123458L11.8192 0.184424C12.0384 0.407969 12.0583 0.75778 11.879 1.00428L11.8192 1.0749L6.43649 6.56558C6.21734 6.78912 5.8744 6.80944 5.63275 6.62654L5.56351 6.56558L0.180798 1.0749C-0.0602665 0.829004 -0.0602665 0.430323 0.180798 0.184424Z" fill="#200E32" />
                                    </svg>


                                </div>
                            </div>
                        </div>

                        {Number(select_id) === 1 ?
                            <>
                                <div className="container mt-3">
                                    <div className="row"
                                        style={{
                                            backgroundColor: "#F9FAFE",
                                            borderRadius: "10px",
                                            height: "27px"
                                        }}
                                    >
                                        <div className="col-5">
                                            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="4" cy="4" r="4" fill="#3DB3A8" />
                                            </svg>
                                            <span
                                                style={{
                                                    fontStyle: "normal",
                                                    fontWeight: "600",
                                                    fontSize: "12px",
                                                    lineHeight: "14px",
                                                    color: "#3DB3A8",
                                                    alignItems: "center",
                                                    textAlign: "center",
                                                    marginLeft: "3px"
                                                }}
                                            >

                                                {props.location.state.data.ModelName1}
                                            </span>

                                        </div>
                                        <div className="col-2" style={{ textAlign: "center" }}>
                                            <span
                                                style={{
                                                    fontStyle: "normal",
                                                    fontWeight: "600",
                                                    fontSize: "12px",
                                                    lineHeight: "14px",
                                                    color: "#3DB3A8",
                                                    alignItems: "center",
                                                    textAlign: "center"
                                                }}
                                            >
                                                Model
                                            </span>

                                        </div>
                                        <div className="col-5" style={{ textAlign: "end" }}>
                                            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="4" cy="4" r="4" fill="#EBB63F" />
                                            </svg>
                                            <span
                                                style={{
                                                    fontStyle: "normal",
                                                    fontWeight: "600",
                                                    fontSize: "12px",
                                                    lineHeight: "14px",
                                                    color: "#EBB63F",
                                                    alignItems: "center",
                                                    textAlign: "center",
                                                    marginLeft: "3px"
                                                }}
                                            >

                                                {props.location.state.data.ModelName2}
                                            </span>

                                        </div>
                                    </div>
                                </div>

                                <div className="container mt-1">
                                    <div className="row"
                                        style={{
                                            backgroundColor: "#F9FAFE",
                                            borderRadius: "10px",
                                            height: "50px",
                                            alignItems: "center",

                                        }}
                                    >
                                        <div className="col-3">

                                            <span
                                                style={{
                                                    fontStyle: "normal",
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    lineHeight: "17px",
                                                    color: "#14274C",
                                                    marginLeft: "3px"
                                                }}
                                            >
                                                {mode === 0 ? setDegitSalary(props.location.state.data.ETcoRadio1) : setDegitSalary(props.location.state.data.TcoRadio1)}

                                            </span>

                                        </div>
                                        <div className="col-6" style={{ textAlign: "center" }}>
                                            <span
                                                style={{
                                                    fontStyle: "normal",
                                                    fontWeight: "600",
                                                    fontSize: "12px",
                                                    lineHeight: "14px",
                                                    color: "#3DB3A8",
                                                    alignItems: "center",
                                                    textAlign: "center"
                                                }}
                                            >
                                                TCO ratio<br />
                                                ({props.location.state.currency}/h)
                                            </span>

                                        </div>
                                        <div className="col-3" style={{ textAlign: "end" }}>

                                            <span
                                                style={{
                                                    fontStyle: "normal",
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    lineHeight: "17px",
                                                    color: "#14274C",
                                                    textAlign: "right"
                                                }}
                                            >
                                                {mode === 0 ? setDegitSalary(props.location.state.data.ETcoRadio2) : setDegitSalary(props.location.state.data.TcoRadio2)}

                                            </span>

                                        </div>
                                    </div>
                                </div>

                                <div className="container mt-1">
                                    <div className="row"
                                        style={{
                                            backgroundColor: "#F9FAFE",
                                            borderRadius: "10px",
                                            height: "50px",
                                            alignItems: "center",

                                        }}
                                    >
                                        <div className="col-3">

                                            <span
                                                style={{
                                                    fontStyle: "normal",
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    lineHeight: "17px",
                                                    color: "#14274C",
                                                    marginLeft: "3px"
                                                }}
                                            >
                                                {mode === 0 ? setDegitSalary(props.location.state.data.EProdRadio1) : setDegitSalary(props.location.state.data.ProdRadio1)}

                                            </span>

                                        </div>
                                        <div className="col-6" style={{ textAlign: "center" }}>
                                            <span
                                                style={{
                                                    fontStyle: "normal",
                                                    fontWeight: "600",
                                                    fontSize: "12px",
                                                    lineHeight: "14px",
                                                    color: "#3DB3A8",
                                                    alignItems: "center",
                                                    textAlign: "center"
                                                }}
                                            >
                                                Productivity ratio<br />
                                                (<>m<sup>3</sup></>/h)
                                            </span>

                                        </div>
                                        <div className="col-3" style={{ textAlign: "end" }}>

                                            <span
                                                style={{
                                                    fontStyle: "normal",
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    lineHeight: "17px",
                                                    color: "#14274C",
                                                    textAlign: "right"
                                                }}
                                            >
                                                {mode === 0 ? setDegitSalary(props.location.state.data.EProdRadio2) : setDegitSalary(props.location.state.data.ProdRadio2)}
                                            </span>

                                        </div>
                                    </div>
                                </div>

                                <div className="container mt-1">
                                    <div className="row"
                                        style={{
                                            backgroundColor: "#F9FAFE",
                                            borderRadius: "10px",
                                            height: "50px",
                                            alignItems: "center",

                                        }}
                                    >
                                        <div className="col-3">

                                            <span
                                                style={{
                                                    fontStyle: "normal",
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    lineHeight: "17px",
                                                    color: "#14274C",
                                                    marginLeft: "3px"
                                                }}
                                            >
                                                {mode === 0 ? setDegitSalary(props.location.state.data.ETcoProd1) : setDegitSalary(props.location.state.data.TcoProd1)}

                                            </span>

                                        </div>
                                        <div className="col-6" style={{ textAlign: "center" }}>
                                            <span
                                                style={{
                                                    fontStyle: "normal",
                                                    fontWeight: "600",
                                                    fontSize: "12px",
                                                    lineHeight: "14px",
                                                    color: "#3DB3A8",
                                                    alignItems: "center",
                                                    textAlign: "center"
                                                }}
                                            >
                                                TCO/Productivity ratio
                                                <br />({props.location.state.currency}/m³)

                                            </span>

                                        </div>
                                        <div className="col-3" style={{ textAlign: "end" }}>

                                            <span
                                                style={{
                                                    fontStyle: "normal",
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    lineHeight: "17px",
                                                    color: "#14274C",
                                                    textAlign: "right"
                                                }}
                                            >
                                                {mode === 0 ? setDegitSalary(props.location.state.data.ETcoProd2) : setDegitSalary(props.location.state.data.TcoProd2)}

                                            </span>

                                        </div>
                                    </div>
                                </div>

                                <div style={{
                                    textAlign: "center",
                                    alignItems: "center",
                                    paddingTop: "10px"
                                }} >
                                    {mode === 0 ?
                                        <span
                                            style={{
                                                fontStyle: "normal",
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                lineHeight: "17px",
                                                color: "#14274C",
                                                textAlign: "center",
                                                marginLeft: "3px",
                                                // color: "red",
                                                // textDecoration: "red underline",
                                            }}
                                        > {props.location.state.data.ETcoProdCompareResult} </span>
                                        :
                                        <span
                                            style={{
                                                fontStyle: "normal",
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                lineHeight: "17px",
                                                color: "#14274C",
                                                textAlign: "center",
                                                marginLeft: "3px",
                                                // color: "red",
                                                // textDecoration: "red underline",

                                            }}
                                        > {props.location.state.data.TcoProdCompareResult}</span>
                                    }
                                </div>
                            </> : null}


                        <div className="save_graph">
                            <Chart
                                options={graph11.options}
                                series={graph11.series}
                                type="bar" />

                            <Chart
                                options={graph12.options}
                                series={graph12.series}
                                type="bar" />

                            <Chart
                                options={graph13.options}
                                series={graph13.series}
                                type="bar" />
                        </div>

                        {select_id === 2 ?
                            <>
                                <div className="container"
                                >
                                    <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                                        <div className="carousel-inner">
                                            <div className="carousel-item active">
                                                <Chart
                                                    options={graph11.options}
                                                    series={graph11.series}
                                                    type="bar"
                                                />
                                            </div>
                                            <div className="carousel-item">
                                                <Chart
                                                    options={graph12.options}
                                                    series={graph12.series}
                                                    type="bar"
                                                />
                                            </div>
                                            <div className="carousel-item">
                                                <Chart
                                                    options={graph13.options}
                                                    series={graph13.series}
                                                    type="bar"
                                                />
                                            </div>
                                        </div>

                                        <div className="carousel-indicators">
                                            <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
                                            <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                                            <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                                        </div>

                                    </div>
                                </div>
                            </>
                            : null
                        }


                        {select_id === 3 ?
                            <>
                                <div className="container"
                                >
                                    <Chart
                                        options={graph2.options}
                                        series={graph2.series}
                                        type="bar"
                                    />
                                </div>

                            </>
                            : null
                        }

                        {select_id === 4 ?
                            <>
                                <wjChart.FlexChart itemsSource={graph3data} bindingX="date">
                                    <wjChartAnalytics.FlexChartWaterfall binding="sales" initialized={onWaterfallInitialized}></wjChartAnalytics.FlexChartWaterfall>
                                    <wjChart.FlexChartDataLabel content='<tspan fill="black" stroke="black">{sales2}</tspan>'></wjChart.FlexChartDataLabel>
                                </wjChart.FlexChart>

                                {/* <Chart2
                                    chartType="CandlestickChart"
                                    width="100%"
                                    data={graph3data}
                                    options={graph3}
                                /> */}

                            </>
                            : null
                        }
                        {select_id === 5 ?
                            <>
                                <wjChart.FlexChart itemsSource={graph4data} bindingX="date">
                                    <wjChartAnalytics.FlexChartWaterfall binding="sales" initialized={onWaterfallInitialized}></wjChartAnalytics.FlexChartWaterfall>
                                    <wjChart.FlexChartDataLabel content='<tspan fill="black" stroke="black">{sales2}</tspan>'></wjChart.FlexChartDataLabel>
                                </wjChart.FlexChart>

                                {/* <Chart2
                                    chartType="CandlestickChart"
                                    width="100%"
                                    data={graph4data}
                                    options={graph4}
                                /> */}
                            </>
                            : null
                        }
                    </div>

                </div>
                <div>
                </div>
                <div className="container" style={{ marginTop: "110px" }}>
                </div>
            </div>


            <div className="sticky-buttom">
                <div className="container">
                    <div>
                        <a
                            className="nav-link active fullwidth"
                            style={{
                                background: "#140A9A",
                                borderRadius: "5px",
                                height: "50px",
                                color: "#fff",
                                paddingTop: "15px"
                            }}
                            onClick={() => saveScreen()}
                        >
                            Create Report
                        </a>
                    </div>
                </div>
            </div>




            <div className={`Modal ${displayModalSelect ? "Show" : ""}`}>
                <div style={{ marginTop: "10px" }}>
                    <h3>View</h3>
                </div>

                <button
                    className="Close"
                    onClick={() => handleDisplayModalSelect(!displayModalSelect)}
                >
                    X
                </button>
                <hr />

                {dataselect.length > 0 ? dataselect.map((item, key) => {
                    return (
                        <div key={key} className="container" onClick={() => selectItemSelect(item)}>
                            <p>{item.name}</p>
                            <hr />

                        </div>
                    )
                }) : "No data"}
            </div>

            <div
                className={`Overlay ${displayModalSelect ? "Show" : ""}`}
                onClick={() => handleDisplayModalSelect(!displayModalSelect)}
            />

        </>
    )
}

export default ViewTCO
